import * as angular from 'angular';
import * as _ from "lodash";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsEvents} from "../../shared/dto/aps.events";
import {SectionActivity} from "../../models/activity/shopActivity";
import {DowntimeActivity} from "../../models/activity/gobActivity";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import DowntimeServiceName, {DowntimeService} from "../../services/downtimes/downtime.service";
import AuthServiceName, {AuthService} from "../../services/auth/auth.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import template from './addDowntime.tpl.html';
import {DowntimeReason, DowntimeType} from "../../models/downtime";

let requires = [LoaderServiceName, NotifyServiceName, DowntimeServiceName, AuthServiceName, NewGuidServiceName];

export default angular.module('aps.controller.downtimes', requires)
  .controller('AddDowntimeCtrl', addDowntimeCtrl)
  .name;

export interface AddDowntimeData {
  downtime: DowntimeActivity,
  section: SectionActivity,
  shopId: string,
  timeZoneId: string,
  date: Date,
  readOnly: boolean,
  canComment: boolean
}

export function openAddDowntime(data: AddDowntimeData,
                                $modal: mm.foundation.modal): angular.IPromise<apsEvents.DowntimeAdded[]> {
  return $modal.open({
    template: template,
    controller: 'AddDowntimeCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

interface AddDowntimeController {
  form: angular.IFormController;
  downtimeType: DowntimeType;
  downtimeReasonDescription: string;
  downtimeTypes: DowntimeType[];
  downtimeReasons: DowntimeReason[];
  sectionNumbers: number[];
  selections: SectionSelection[];
  createdBy: string;
  downtimeReason: DowntimeReason;
  maxTime: string;
  minTime: string;
  startTime: Date;
  comments: apsViewModels.DowntimeDetailsComment[];
  canComment: boolean;
  readOnly: boolean;
  timeZoneId: string;
  displaySections: boolean;
  entireMachine: boolean;
  downtimeComment: string;
  duration: string;
  readyForSubmit: boolean;
  isMachineId: string;
  sections: SectionActivity[];
  shopId: string;
  section: SectionActivity;
  editMode: boolean;
  canAddDuration: boolean;

  cancel(): void;
  sectionAndMachineSelectionIsValid(): boolean;
  toggleSections(): void;
  typeChanged(): void;
  filterDowntimeReasons(downtimeReason: DowntimeReason): boolean;
  formatTime(time: Date): string;
  sectionsUpdated(): void;
  addDowntime(): void;
  saveDowntime(): void;
  deleteDowntime(): void;
}

interface SectionSelection {
}

function addDowntimeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  $q: angular.IQService,
  loaderService: LoaderService,
  downtimeService: DowntimeService,
  data: AddDowntimeData,
  notifyService: NotifyService,
  $timeout: angular.ITimeoutService,
  authService: AuthService,
  newGuidService: NewGuidService) {

  let vm = this as AddDowntimeController;

  vm.canAddDuration = true;

  vm.editMode = false;
  vm.section = data.section;
  vm.shopId = data.shopId;
  vm.sections = data.section.machine.sections;
  vm.isMachineId = data.section.machine.id;
  vm.readyForSubmit = false;

  vm.duration = '';
  vm.downtimeComment = '';
  vm.entireMachine = false;
  vm.displaySections = false;
  vm.timeZoneId = data.timeZoneId;
  vm.readOnly = data.readOnly;
  vm.canComment = data.canComment;

  if (data.downtime) {
    vm.editMode = true;
    vm.comments = data.downtime.comments;
  }

  let range = DateUtilityService.getHourRange(data.date, vm.timeZoneId);
  vm.startTime = vm.editMode ? data.downtime.downtimeStart : range.initialTime.toDate();
  vm.minTime = range.minTime;
  vm.maxTime = range.maxTime;

  vm.formatTime = function(time) {
    return DateUtilityService.formatTime(time, vm.timeZoneId);
  };

  if (vm.editMode) {
    vm.canAddDuration = !(data.downtime.duration > 0);
    if (data.downtime.duration) {
      vm.duration = data.downtime.duration.toString(10);
    }
    vm.displaySections = data.downtime.section > 0;
    vm.entireMachine = !vm.displaySections;
    vm.downtimeReasonDescription = data.downtime.downtimeReasonDescription;
    vm.createdBy = data.downtime.createdByFullName;
  }

  let selections: SectionSelection[] = [];
  _.forEach(vm.sections, function(section: SectionActivity) {
    let sectionSelection: SectionSelection = {
      section: section,
      selected: data.section === section
    };
    selections.push(sectionSelection);
  });
  vm.selections = selections;

  let ids = [], commentIds = [];

  let updateIsReady = function() {
    if (vm.editMode) {
      vm.readyForSubmit = true;
      return;
    }

    if (vm.sectionNumbers && vm.sectionNumbers.length > 0) {
      vm.readyForSubmit = ids.length >= vm.sectionNumbers.length
        && commentIds.length >= vm.sectionNumbers.length;
    } else {
      vm.readyForSubmit = ids.length >= 1 && commentIds.length >= 1;
    }
  };

  vm.sectionAndMachineSelectionIsValid = function() {

    if (vm.downtimeReason && vm.downtimeReason.entireMachine) {
      vm.entireMachine = true;
      vm.sectionNumbers = [];
      return true;
    }

    vm.entireMachine = false;
    vm.sectionNumbers =
      _.map(
        _.filter(vm.selections, function(selection) {
          return (<any>selection).selected === true;
        }),
        'section.sectionNumber');
    updateIsReady();
    return vm.sectionNumbers.length > 0;
  };

  let getTypesAndReasons = downtimeService.getDowntimeTypesAndReasons()
    .then(function(data) {
      vm.downtimeReasons = data.downtimeReasons;
      vm.downtimeTypes = data.downtimeTypes;
    });

  loaderService.loadingPromise(getTypesAndReasons);

  vm.filterDowntimeReasons = function(downtimeReason: DowntimeReason) {
    return !vm.downtimeType ||
      downtimeReason.downtimeType === vm.downtimeType;
  };

  vm.typeChanged = function() {
    if (vm.downtimeReason && vm.downtimeType && vm.downtimeReason.downtimeType !== vm.downtimeType) {
      vm.downtimeReason = undefined;
      vm.toggleSections();
    }
  };

  vm.toggleSections = function() {
    vm.displaySections = vm.downtimeReason && !vm.downtimeReason.entireMachine;
    vm.entireMachine = !vm.displaySections;

    if (!vm.displaySections) {
      vm.sectionNumbers = [];
    }
  };

  vm.cancel = function() {
    $modalInstance.close();
  };

  let userData: apsViewModels.UserData;
  let promises: angular.IPromise<any>[] = [
    authService.getUserData().then(x => userData = x),
    newGuidService.getNewGuid('downtimeComment').then(x => commentIds.push(x))
  ];
  if (!vm.editMode) {
    promises.push(newGuidService.getNewGuid('downtime').then(x => ids.push(x)));
  }
  $q.all(promises).then(() => updateIsReady());

  vm.sectionsUpdated = function() {
    $timeout(() => {
      vm.sectionAndMachineSelectionIsValid();

      if (!vm.readyForSubmit) {
        $q.all([
          newGuidService.getNewGuid('downtime').then(x => ids.push(x)),
          newGuidService.getNewGuid('downtimeComment').then(x => commentIds.push(x))
        ]).then(() => updateIsReady());
      }
    }, 100);
  };

  vm.addDowntime = function() {
    if (vm.form.$invalid || !vm.sectionAndMachineSelectionIsValid() || !vm.readyForSubmit) {
      return false;
    }

    let downtimes: apsCommands.AddDowntime[] = [];
    if (vm.entireMachine) {
      downtimes.push({
        id: ids[0],
        entireMachine: true,
        sectionNumber: null,
        comment: vm.downtimeComment,
        commentId: vm.downtimeComment ? commentIds[0] : undefined
      });
    } else {
      for (let i = 0; i < vm.sectionNumbers.length; i++) {
        downtimes.push({
          id: ids[i],
          entireMachine: false,
          sectionNumber: vm.sectionNumbers[i],
          comment: vm.downtimeComment,
          commentId: vm.downtimeComment ? commentIds[i] : undefined
        });
      }
    }

    let cmd: apsCommands.AddDowntimeBatch = {
      shopId: vm.shopId,
      isMachineId: vm.isMachineId,
      downtimeReasonId: vm.downtimeReason.id,
      duration: vm.duration ? parseInt(vm.duration, 10) : null,
      downtimeStart: vm.startTime,
      downtimes: downtimes
    };

    let events = [];
    _.forEach(cmd.downtimes, (section) => {
      let event: apsEvents.DowntimeAdded = {
        id: section.id,
        plantId: undefined,
        shopId: cmd.shopId,
        isMachineId: cmd.isMachineId,
        jobRunId: undefined, // not used
        downtimeStart: cmd.downtimeStart,
        duration: cmd.duration,
        section: section.sectionNumber,
        createdByFullName: userData.fullName,
        downtimeReasonId: cmd.downtimeReasonId,
        downtimeReasonCode: vm.downtimeReason.code,
        downtimeReasonDescription: vm.downtimeReason.description,
        comments: [],
        userId: userData.id,
        eventDate: new Date()
      };

      if (section.comment) {
        event.comments = [{
          id: section.commentId,
          plantId: undefined,
          jobRunId: undefined,
          shopId: cmd.shopId,
          isMachineId: cmd.isMachineId,
          section: event.section,
          duration: cmd.duration,
          downtimeId: section.id,
          downtimeStart: cmd.downtimeStart,
          comment: section.comment,
          createdByFullName: event.createdByFullName,
          userId: event.userId,
          eventDate: event.eventDate
        }];
      }

      events.push(event);
    });

    let promise = downtimeService.addDowntime(cmd)
      .then(function() {
        $modalInstance.close(events);
      }, notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.saveDowntime = function() {
    if (!vm.editMode) {
      vm.addDowntime();
      return;
    }

    if (vm.form.$invalid) {
      return false;
    }

    let cmd: apsCommands.AddDowntimeDurationOrComment = {
      id: data.downtime.id,
      duration: vm.duration ? parseInt(vm.duration, 10) : null,
      comment: vm.downtimeComment,
      downtimeStart: data.downtime.downtimeStart,
      shopId: vm.shopId
    };
    let promise = downtimeService.saveDowntime(cmd)
      .then(function() {
        $modalInstance.close();
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.deleteDowntime = function() {
    let promise = downtimeService
      .deleteDowntime({ id: data.downtime.id })
      .then(function () {
        $modalInstance.close();
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/downtime/addDowntime.controller.ts